export class PartnerRelationship {
  partnerId: number;
  childrenIds: number[];

  public constructor(init?: Partial<PartnerRelationship>) {
    Object.assign(this, init);
  }

  toJSON(): any {
    return {
      partnerId: this.partnerId,
      childrenIds: this.childrenIds,
    };
  }
}
